//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defaultBlockProps } from "~/helpers/data";

export default {
    name: "BowGallery",
    props: {
        ...defaultBlockProps,

        withParallax: {
            default: true,
            type: Boolean,
        },
    },

    data: () => ({
        images: [],
    }),

    fetch() {
        this.images = this.media.filter((item) => item.type === "image");
    },

    mounted() {
        // Add height to parallax element
        // if ( this.$el && this.$el.querySelector('.a-parallax') ) {
        //   let height = 0;
        //   [...this.$el.children].forEach((el) => {
        //     if ( !el.classList.value.includes('a-parallax') ) {
        //       height += el.getBoundingClientRect().height;
        //     }
        //   });
        //   const parallaxElement = this.$el.querySelector('.a-parallax');
        //   parallaxElement.setAttribute('style', `height:${height * 3.5}px`);
        // }
    },
};
